var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.currentLOBDetails.LOBId > 1)?_c('ProducerSalesReportFiling'):_c('DistributorSalesReportFiling')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }